import { RouteChildrenProps } from "react-router";
import { ROUTE_PATHS } from "../../../constants/url-config";
import i18n from "../../../utils/i18n";
import { StatisticIcon } from "../../atoms/icon";
import AppMainCard, { MainCardProp } from "../../atoms/main-card";


const ITEMS: MainCardProp[] = [
    {
        index: 1,
        name: i18n.t("ERMModule.lbControlFailure"),
        description: i18n.t("ERMModule.lbControlFailureDes"),
        icon: <StatisticIcon />,
        link: ROUTE_PATHS.ControlFailure
    },
    {
        index: 2,
        name: i18n.t("ERMModule.lbScenariosAssessment"),
        description: i18n.t("ERMModule.lbScenariosAssessmentDes"),
        icon: <StatisticIcon />,
        link: ROUTE_PATHS.Scenarios
    }
]

interface Props extends RouteChildrenProps { }

const ERMModule = (props: Props) => {

    return (
        <AppMainCard items={ITEMS}/>
    )
}

export default ERMModule